import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@welldev-group/rcl-icon';
import Modal from '@welldev-group/rcl-modal';

const ActionConfirmationModal = ({ isVisible, title, subTitle, footer }) => {
  return (
    <Modal className="action-confiramtion-modal" isVisible={isVisible}>
      <Modal.Content className="action-confiramtion-modal__body" align="center">
        <Icon
          className="action-confiramtion-modal__body-success-icon"
          name="check"
          showBGColor={true}
          color="success"
        />
        <div className="action-confiramtion-modal__body-greeting-text">
          {title}
        </div>
        <div className="action-confiramtion-modal__body-success-text">
          {subTitle}
        </div>
      </Modal.Content>
      <Modal.Footer className="action-confiramtion-modal__footer">
        {footer}
      </Modal.Footer>
    </Modal>
  );
};

ActionConfirmationModal.defaultProps = {
  isVisible: false,
  title: '',
  subTitle: '',
  footer: null,
};

ActionConfirmationModal.propTypes = {
  isVisible: PropTypes.bool,
  title: PropTypes.string,
  subTitle: PropTypes.string,
  footer: PropTypes.node,
};

export default ActionConfirmationModal;
